import { ChannelMemberData } from 'src/components/ChannelListItem';
import { Company, User } from 'src/constants';

export const getChannelAvatarInfo = (
  cuId: string,
  channelCoId: string,
  clientsMap: Map<string, User>,
  companiesMap: Map<string, Company>,
) => {
  const client = clientsMap.get(cuId);
  let channelTitle = '';
  if (client) {
    channelTitle = `${client.fields.givenName} ${client.fields.familyName}`;
    const info: ChannelMemberData = {
      name: `${client.fields.givenName} ${client.fields.familyName}`,
      avatar: client.fields.avatarImageUrl || '',
      fallbackColor: client.fields.fallbackColor || '',
    };
    // if client belongs to multiple companies, show company name as sub avatar info
    if (client.fields.companyIds && client.fields.companyIds.length > 1) {
      const company = companiesMap.get(channelCoId);
      if (company) {
        info.subAvatarInfo = {
          name: company.fields.name,
          avatar: company.fields.avatarImageURL || '',
          fallbackColor: company.fields.fallbackColor || '',
        };
        channelTitle = `${client.fields.givenName} ${client.fields.familyName} (${company.fields.name})`;
      }
    }
    return {
      avatarInfo: [info],
      title: channelTitle,
    };
  }
  return {
    avatarInfo: [],
    title: channelTitle,
  };
};
